import { yearInReviewsClient } from "../api/ApiClients";
import ServiceBase from "./ServiceBase";
import {
  ClientYearAnalyticsDto,
  CoachYearAnalyticsDto,
} from "@growth-machine-llc/stridist-api-client";

class YearReviewAnalyticsService extends ServiceBase {
  async getCoachYearAnalytics(
    coachId: number,
    year: number,
  ): Promise<CoachYearAnalyticsDto> {
    return yearInReviewsClient.getCoachYearAnalytics(coachId, year);
  }
  async getClientYearAnalytics(
    clientId: number,
    year: number,
  ): Promise<ClientYearAnalyticsDto> {
    return yearInReviewsClient.getClientYearAnalytics(clientId, year);
  }
}

export default new YearReviewAnalyticsService();
